<div class="sidebar" [class.is-collapsed]="collapsed()">

  <ul class="menu">
    <ng-container *ngTemplateOutlet="menuItems; context: { $implicit: menu, level: 0 }"></ng-container>
  </ul>

  <ng-template #menuItems let-items let-level="level">
    @for (item of items; track item.label) {
      @if (item.type !== 'group') {
        <li>
          <a [class]="level === 0 ? 'item' : 'subitem'"
            [routerLink]="item.path"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="handleNavigation()">
          <i class="bi" [class]="item.icon"></i>
          <span class="label">{{ item.label }}</span>
          </a>
        </li>
      }

      @if (item.type === 'group') {
        <li class="group" [class.nested-group]="level > 0">

          <button
            type="button"
            [class]="level === 0 ? 'group-header' : 'subgroup-header'"
            [class.active]="isGroupActive(item)"
            [class.is-open]="isGroupOpen(item.label)"
            [attr.aria-expanded]="isGroupOpen(item.label)"
            (click)="toggleGroup(item.label)">
            <i class="bi" [class]="item.icon"></i>
            <span class="label">{{ item.label }}</span>
          </button>

          @if (!collapsed() && isGroupOpen(item.label)) {
            <ul class="submenu" [class.submenu-nested]="level > 0">
              <ng-container *ngTemplateOutlet="menuItems; context: { $implicit: item.children, level: level + 1 }"></ng-container>
            </ul>
          }
        </li>
      }

    }
  </ng-template>
</div>
